import React from 'react';
import { Button, Card, CardActionArea, Typography } from '@mui/material';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';


export function FeedbackCard(props) {

    return <Card sx={{ background: "var(--color-secondary-soft)" }}>
        <CardContent>
            <Typography gutterBottom variant="h6" component="div">
                Feedback?
            </Typography>
            <Typography variant="body2" color="text.secondary">
                I'd love to hear it.
            </Typography>
        </CardContent>
        <CardActions  >
            <Button 
                variant="contained" 
                size="small" 
                onClick={ e => { window.open("https://discord.gg/eVG6PP7k8Y", "_blank")
                    }} >
                    Join discord</Button>
        </CardActions>

    </Card>;
}
